import React from 'react';
import './index.css';

/**
 *
 * @param {any} children
 * @param {String} type
 */

const Button = ({ children, type, clickHandler, classNames, disabled=false }) => {
	return (
		<button type='button' className={`btn ${type} ${classNames}`} onClick={clickHandler} disabled={disabled}>
			{children}
		</button>
	);
};

export default Button;
